// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { useEffect, type ReactNode } from "react";
import { PageLoader } from "../components/layout/PageLoader";
import { useTeamsEnabled } from "../context/FeatureFlagsContext";
import { navigateTo } from "../router/navigation";

export function TeamsOnlyRoute({ children }: { children: ReactNode }) {
  const { teams, settled } = useTeamsEnabled();

  useEffect(() => {
    if (settled && !teams) {
      navigateTo("/", { replace: true });
    }
  }, [settled, teams]);

  return teams ? <>{children}</> : <PageLoader />;
}
